import _objectWithoutProperties from "@babel/runtime/helpers/esm/objectWithoutProperties";
import _classCallCheck from "@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "@babel/runtime/helpers/esm/createClass";
import _possibleConstructorReturn from "@babel/runtime/helpers/esm/possibleConstructorReturn";
import _getPrototypeOf from "@babel/runtime/helpers/esm/getPrototypeOf";
import _inherits from "@babel/runtime/helpers/esm/inherits";
import React, { Component, cloneElement } from 'react';
import styled from 'styled-components';
import PropTypes from 'prop-types';
import OverlayTrigger from "../OverlayTrigger";
import { overlayDirections } from "../../styles/mixins/overlays";
var TriggerContainer = styled.span.withConfig({
  displayName: "PopoverTrigger__TriggerContainer",
  componentId: "sc-1ypx2u3-0"
})(["display:inline-flex;"]);

var PopoverTrigger =
/*#__PURE__*/
function (_Component) {
  _inherits(PopoverTrigger, _Component);

  function PopoverTrigger() {
    var _getPrototypeOf2;

    var _this;

    _classCallCheck(this, PopoverTrigger);

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = _possibleConstructorReturn(this, (_getPrototypeOf2 = _getPrototypeOf(PopoverTrigger)).call.apply(_getPrototypeOf2, [this].concat(args)));
    _this.element = React.createRef();

    _this.onToggle = function (e) {
      if (_this.props.overlay) {
        _this.props.onHide(e);
      } else {
        _this.props.onShow(e);
      }
    };

    _this.onWindowEvent = function (e) {
      if (_this.props.overlay) {
        if (_this.element.current && !_this.element.current.contains(e.target)) {
          _this.props.onHide(e);
        }
      }
    };

    return _this;
  }

  _createClass(PopoverTrigger, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      window.addEventListener('click', this.onWindowEvent, true);
    }
  }, {
    key: "componentWillUnmount",
    value: function componentWillUnmount() {
      window.removeEventListener('click', this.onWindowEvent, true);
    }
  }, {
    key: "render",
    value: function render() {
      var _this$props = this.props,
          children = _this$props.children,
          overlay = _this$props.overlay,
          onShow = _this$props.onShow,
          onHide = _this$props.onHide,
          overlayTriggerProps = _objectWithoutProperties(_this$props, ["children", "overlay", "onShow", "onHide"]);

      return React.createElement(OverlayTrigger, Object.assign({}, overlayTriggerProps, {
        ref: this.element,
        overlay: overlay && cloneElement(overlay, {
          onClose: this.onToggle
        })
      }), React.createElement(TriggerContainer, {
        role: "presentation",
        onClick: this.onToggle
      }, children));
    }
  }]);

  return PopoverTrigger;
}(Component); // export placement options


PopoverTrigger.propTypes = {
  /** Where the overlay will appear in relation to its target */
  placement: PropTypes.oneOf(['top', 'topRight', 'topLeft', 'left', 'leftTop', 'leftBottom', 'bottom', 'bottomLeft', 'bottomRight', 'right', 'rightTop', 'rightBottom']),

  /** Can accept any JSX, meant for a Popover component */
  overlay: PropTypes.node,

  /** Can accept an JSX, meant for a button or icon that triggers the popover */
  children: PropTypes.node,

  /**
   * Callback function to indicate that the Popover should be shown
   * @argument {Function} event The event that triggered this function
   */
  onShow: PropTypes.func,

  /**
   * Callback function to indicate that the Popover should be hidden
   * @argument {Function} event The event that triggered this function
   */
  onHide: PropTypes.func
};
PopoverTrigger.defaultProps = {
  onShow: function onShow() {},
  onHide: function onHide() {}
};
export { PopoverTrigger as default };
Object.keys(overlayDirections).forEach(function (placement) {
  PopoverTrigger[placement] = placement;
});